const lineChart = (() => {
	/**
	 * init : initializing bar group chart
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 * @param config object
	 */
	const init = (config) => {
		const { width, height, margin, color, duration, lineOpacity, circleOpacity, circleRadius } = config, gredientHeight = height - margin;

		/* Format Data */
		const parseDate = d3.timeParse("%Y-%m");
		config.data.forEach(function (d) {
			d.values.forEach(function (d) {
				d.date = parseDate(d.date);
				d.price = +d.price;
			});
		});


		const tooltip = d3.select("body")
			.append('div')
			.attr('class', 'tooltip');

		const areaFunction = d3.area()
			.x(d => xScale(d.date))
			.y0(gredientHeight)
			.y1(d => yScale(d.price));



		if (config.curve) areaFunction.curve(d3.curveMonotoneX);


		/* Scale */
		const xScale = d3.scaleLinear()
			.domain(d3.extent(config.data[0].values, d => d.date))
			.range([0, width - margin]);
		let mx = 0, mn = 0;
		for (let i = 0; i < config.data.length; ++i) {
			mn = Math.min(d3.min(config.data[i].values, d => d.price), mn);
			mx = Math.max(d3.max(config.data[i].values, d => d.price), mx);
		}
		const yScale = d3.scaleLinear()
			.domain([0, mx + (mx < 5 ? 10 : 1)])
			.range([height - margin, 0]);

		/* Add SVG */
		const svg = d3.select(config.id)
			.append("svg")
			.attr("width", (width + margin) + "px")
			.attr("height", (height + margin) + "px")
			.append('g')
			.attr("transform", `translate(${margin}, ${margin})`);

		// var area_gradient = {};

		// area_gradient["field0"] = svg.append('defs')
		// .append("linearGradient")
		// .attr('id', "field0")
		// .attr("x1", "0%").attr("y1", "0%")
		// .attr("x2", "0%").attr("y2", "100%")
		// .selectAll("stop")
		// .data([
		// 	{ offset: "0%", color: "white", opacity: 0.2 },
		// 	{ offset: "30%", color: "#32a4f7", opacity: 0.1 },
		// 	{offset: "40%", color: "#32a4f7", opacity: 0.1},
		// 	{offset: "40%", color: "#32a4f7", opacity: 0.1},
		// 	{ offset: "100%", color: "#32a4f7", opacity: 0.5 }
		// ])
		// .enter().append("stop")
		// .attr("offset", function (d) { return d.offset; })
		// .attr("stop-color", function (d) { return d.color; })
		// .attr("stop-opacity", function (d) { return d.opacity; })

		// area_gradient["field1"] = svg.append('defs')
		// 	.append("linearGradient")
		// 	.attr('id', "field1")
		// 	.attr("x1", "0%").attr("y1", "0%")
		// 	.attr("x2", "0%").attr("y2", "100%")
		// 	.selectAll("stop")
		// 	.data([
		// 		{ offset: "0%", color: "white", opacity: 0.2 },
		// 		{ offset: "30%", color: "#00CB96", opacity: 0.1 },
		// 		{offset: "40%", color: "#00CB96", opacity: 0.1},
		// 		{offset: "40%", color: "#00CB96", opacity: 0.1},
		// 		{ offset: "100%", color: "#00CB96", opacity: 0.5 }
		// 	// 	{ offset: "40%", color: "#00CB96", opacity: 0.6 },
		// 	// 	{ offset: "60%", color: "#00CB96", opacity: 0.7 },
		// 	// 	//  {offset: "40%", color: color, opacity: 0.80},
		// 	// 	//  {offset: "40%", color: color, opacity: 0.9},
		// 	// 	//  { offset: "100%", color: color, opacity: 1 }
		// ])
		// .enter().append("stop")
		// .attr("offset", function (d) { return d.offset; })
		// .attr("stop-color", function (d) { return d.color; })
		// .attr("stop-opacity", function (d) { return d.opacity; })



		var area_gradient = {};
		for (let i = 0; i < config.data.length; ++i) {
			const color = config.color[i];
			area_gradient["field" + i] = svg.append('defs')
				.append("linearGradient")
				.attr('id', "field" + i)
				.attr("x1", "0%").attr("y1", "0%")
				.attr("x2", "0%").attr("y2", "100%")
				.selectAll("stop")
				.data([
					{ offset: "0%", color: color, opacity: 0.2 },
					{ offset: "30%", color: color, opacity: 0.1 },
					{offset: "40%", color: color, opacity: 0.1},
					{offset: "40%", color: color, opacity: 0.1},
					{ offset: "100%", color: color, opacity: 0.4 }
				])
				.enter().append("stop")
				.attr("offset", function (d) { return d.offset; })
				.attr("stop-color", function (d) { return d.color; })
				.attr("stop-opacity", function (d) { return d.opacity; })
		}

		// const areaGradient = svg.append('defs')
		// 	.append("linearGradient")
		// 	.attr('id', 'areaGradient')
		// 	.attr("x1", "0%").attr("y1", "0%")
		// 	.attr("x2", "0%").attr("y2", "100%")
		// 	.selectAll("stop")
		// 	.data([
		// 		{ offset: "0%", color: "white", opacity: 0.2 },
		// 		{ offset: "30%", color: "#32a4f7", opacity: 0.1 },
		// 		{offset: "40%", color: "#32a4f7", opacity: 0.1},
		// 		{offset: "40%", color: "#32a4f7", opacity: 0.1},
		// 		{ offset: "100%", color: "#32a4f7", opacity: 0.5 }
		// 	])
		// 	.enter().append("stop")
		// 	.attr("offset", function (d) { return d.offset; })
		// 	.attr("stop-color", function (d) { return d.color; })
		// 	.attr("stop-opacity", function (d) { return d.opacity; });




		/* Add line into SVG */
		const line = d3.line()
			.x(d => xScale(d.date))
			.y(d => yScale(d.price));

		if (config.curve) line.curve(d3.curveMonotoneX);
		let lines = svg.append('g')
			.attr('class', 'lines');



		for (let i = 0; i < config.data.length; ++i) {
			const resp = [];
			for (let j = 0; j < config.data[i].values.length; ++j) {
				resp.push({
					date: config.data[i].values[j].date,
					price: config.data[i].values[j].price
				});
			}
			lines.selectAll('.line-group').data(config.data).enter()
				.append("path")
				.attr("class", "area")
				.style("fill", `url(#field${i})`)
				.attr("d", areaFunction(resp));
		}
		let repeat = () => {
			var data = d3.range(11).map(function(){return Math.random()*10})



			const total_length = d3.select("path").node().getTotalLength();
			d3.selectAll("path")
				.attr("stroke-dasharray", total_length + " " + total_length)
				.attr("stroke-dashoffset", total_length)
				.transition()
				.duration(4000)
				.ease(d3.easeLinear)
				.attr("stroke-dashoffset", 0)
				.on("end", repeat);
		};

		lines.selectAll('.line-group')
			.data(config.data)
			.enter()
			.append('g')
			.attr('class', 'line-group1');
		// const totalLength = svg.select(".line-group1").node().getTotalLength();
		lines.selectAll('.line-group1')
			.append('path')
			.style("opacity","0")
			.attr('class', 'line')
			.transition()
			.duration(400)
			.style("opacity","1")

			.transition()
			.duration(400)
			.attr('d', d => line(d.values))
			.style('stroke', (d, i) => color[i])
			.style('opacity', lineOpacity)

		lines.selectAll('.line-group')
			.transition()
			.duration(duration);



		/* Add circles in the line */
		lines.selectAll("circle-group")
			.data(config.data).enter()
			.append("g")

			.style("fill", (d, i) => color[i])
			.selectAll("circle")
			.data(d => d.values).enter()
			.append("g")
			.style("cursor", "pointer")
			.attr("class", "circle")
			.on("mouseover", function (d, i) {
				const idx = (d.from === "left" || config.data[0].from === "left") ? 0 : 1;
				// if (!!config.callback && !!config.resource) resources[config.resource][config.callback](d, d.from);
				const dd = (config.tooltip.diff === true) ? (initScript.getHTMLElementByDelimiter("hideShowSection1 .row").height() - initScript.getHTMLElementByDelimiter(config.tooltip.diff_class ? config.tooltip.diff_class : "card-body").height()) : 0;
				tooltip.html(initScript.separateNumberByDelimiter(d.price / 1000));
				tooltip
					.style('top', (+this.children[0].getAttribute("cy") + config.tooltip.top + dd) + 'px')
					.style('left', (+this.children[0].getAttribute("cx") + config.tooltip.left) + 'px')
					.style("position", "absolute")
					.style('display', 'block')
					.style('color', color[idx])
					.style('font-weight', 'bold')
					.style('border-color', color[idx])
					.style('opacity', 0.7)
					.append("span")
					.style("border-color", color[idx]);
			})
			.on("mouseout", function (d) {
				tooltip.style('display', 'none')
			})

			.append("circle")
			.attr("cx", d => xScale(d.date))
			.attr("cy", d => yScale(d.price))

			.attr("r", circleRadius)
			.style('opacity', circleOpacity)
			.on("mouseout", function (d) {
				d3.select(this)
					.transition()
					.duration(duration)
					.attr("r", circleRadius);
			});


		/* Add Axis into SVG */
		const xAxis = d3.axisBottom(xScale).ticks(d3.timeMonth.every(1)).tickFormat(d3.timeFormat("%b-%y"));
		const yAxis = d3.axisLeft(yScale).ticks(mx < 5 ? 1 : Math.min(5, config.data[0].values.length)).tickFormat(function(d) {
			return initScript.separateNumberByDelimiterWithSignAndThousand(d);
		});

		svg.append("g")
			.attr("class", "x axis")
			.attr("transform", `translate(0, ${height - margin})`)
			.call(xAxis);

		svg.append("g")
			.attr("class", "y axis")
			.call(yAxis)
			.append('text')
			.attr("y", 15);

	};
	return {
		init,
	};
})();
